import { Address } from "@app.raytd.com/store";
import clsx from "clsx";
import { useMemo } from "react";

interface AddressProps {
  address: Address | null; // Allow address to be null
  separator?: string;
  excludeCountry?: boolean;
  className?: string;
  emptyText?: string;
  twoLines?: boolean;
}

const AddressLine: React.FC<AddressProps> = ({
  address,
  separator = ', ',
  excludeCountry = false,
  className = '',
  emptyText = 'No address available',
  twoLines = false,
}) => {
  // if (!address) {
  //   return <span className={`address-line ${className}`.trim()} title={emptyText}>{emptyText}</span>;
  // }

  const memoizedParts = useMemo(() => {
    if (!address) {
      return [];
    }
    const parts = [
      address.street,
      address.suburb ?? address.city,
      address.state,
      address.postcode,
      excludeCountry ? null : address.country,
    ].filter(Boolean);
    return [...new Set(parts)];
  }, [address, excludeCountry]);

  if (memoizedParts.length === 0) {
    return <span className={clsx('address-line text-sm', className)} title={emptyText}>{emptyText}</span>;
  }
  const baseClassName = clsx('text-sm', className);

  if (twoLines) {
    const [firstLine, ...rest] = memoizedParts;
    const secondLine = rest.join(separator);

    return (
      <div className={baseClassName}>
        <div>{firstLine}</div>
        {/* Only render the second line if it has content */}
        {secondLine && <div>{secondLine}</div>}
      </div>
    );
  }

  const formattedAddress = memoizedParts.join(separator);

  return (
    <div className={clsx(baseClassName, 'truncate')} title={formattedAddress}>
      {formattedAddress}
    </div>
  );
};

export default AddressLine;